module.exports = __webpack_public_path__ + "img/4.6559eff8.png";